// extracted by mini-css-extract-plugin
export var accountPageHeader = "account-page-header_goAC4fbQbF9Qudi2Jjn4";
export var accountPageHeaderMeta = "account-page-header__meta_GxFpYkL_aaDNMTa4pP4w";